/*
 * @Author: Dong
 * @Date: 2022-05-12 19:11:51
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-07 11:14:00
 */
import React from 'react';
import { useIntl } from 'react-intl';
import Icon from 'root/components/Icon';
import { Button, Form, Input, Select } from 'sup-ui';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import messages from './messages';
import styles from './index.less';

interface PropsType {
  form: WrappedFormUtils;
  statusOptions: [];
  namespaceOptions: [];
  applicationOptions: [];
  alertEnabledOptions: [];
  btnDisabled: boolean;
  onBtnClick: (type: string) => void;
  onSubmit: () => void;
}

const { Option } = Select;

const FormSearch = (props: PropsType) => {
  const intl = useIntl();
  const {
    statusOptions,
    alertEnabledOptions,
    btnDisabled,
    onBtnClick,
    onSubmit,
    form,
    applicationOptions,
    namespaceOptions,
  } = props;
  const { getFieldDecorator } = form;

  const handleBtnClick = (type: string) => {
    if (!onBtnClick) return;

    onBtnClick(type);
  };

  return (
    <Form className={styles.form} layout="inline" onSubmit={onSubmit}>
      <Form.Item>
        <Button size="small" disabled={btnDisabled} onClick={() => handleBtnClick('start')}>
          <Icon type="start16" className={styles.iconFontStart} />
          {intl.formatMessage(messages.start)}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button size="small" onClick={() => handleBtnClick('stop')} disabled={btnDisabled}>
          <Icon type="stop16" className={styles.iconFontStop} />
          {intl.formatMessage(messages.stop)}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button size="small" onClick={() => handleBtnClick('restart')} disabled={btnDisabled}>
          <Icon type="reload16" className={styles.iconFontReload} />
          {intl.formatMessage(messages.restart)}
        </Button>
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.serviceName)} colon={false}>
        {getFieldDecorator('serviceName', {
          initialValue: '',
        })(<Input className={styles.queryInput} maxLength={64} />)}
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.status)} colon={false}>
        {getFieldDecorator('status', { initialValue: '' })(
          <Select dropdownMatchSelectWidth={true} style={{ width: 100 }}>
            {statusOptions.map((item: any) => {
              return (
                <Option key={item.name} value={item.value}>
                  {item.name}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.namespace)} colon={false}>
        {getFieldDecorator('namespace')(
          <Select dropdownMatchSelectWidth={true} style={{ width: 100 }}>
            {namespaceOptions.map((item: string) => {
              return (
                <Option key={item} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.application)} colon={false}>
        {getFieldDecorator('application')(
          <Select dropdownMatchSelectWidth={true} style={{ width: 100 }}>
            {applicationOptions.map((item: string) => {
              return (
                <Option key={item} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.alertEnabled)} colon={false}>
        {getFieldDecorator('alert', { initialValue: '' })(
          <Select dropdownMatchSelectWidth={true} style={{ width: 100 }}>
            {alertEnabledOptions.map((item: any) => {
              return (
                <Option key={item.name} value={item.value}>
                  {item.name}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
      <Form.Item>
        <Button size="small" htmlType="submit">
          {intl.formatMessage(messages.query)}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button size="small" onClick={() => handleBtnClick('clearForm')}>
          {intl.formatMessage(messages.reset)}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Form.create()(FormSearch);
